import { render, staticRenderFns } from "./ProducingPanel.vue?vue&type=template&id=560363f2&"
import script from "./ProducingPanel.vue?vue&type=script&lang=js&"
export * from "./ProducingPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports